import axios from "axios";

export const state = {
    visits: [],
};

export const getters = {
    visits: state => state.visits,
};

export const mutations = {
    setVisits(state, newValue) {
        state.visits = newValue
    },
};

export const actions = {
    fetchVisits({ commit }) {
        axios.get('/patientvisits').then(res => {
            commit('setVisits', res.data.visits);
        })
    },
};